export const verificationTypes = {
  VERIFIABLE: "Comprobable",
  NO_VERIFIABLE: "No comprobable"
};
